import api from './api';

export const requestService = {
  /**
   * Créer une demande client (public)
   * @param {Object} data - Données de la demande
   * @returns {Promise}
   */
  createRequest: async (data) => {
    try {
      const response = await api.post('/requests', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la demande:', error);
      throw error;
    }
  },

  /**
   * Récupérer toutes les demandes (Admin/Agent)
   * @param {Object} filters - { statut, page, limit }
   * @returns {Promise}
   */
  getAllRequests: async (filters = {}) => {
    try {
      const response = await api.get('/requests', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des demandes:', error);
      throw error;
    }
  },

  /**
   * Récupérer une demande par ID (Admin/Agent)
   * @param {string} id
   * @returns {Promise}
   */
  getRequestById: async (id) => {
    try {
      const response = await api.get(`/requests/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la demande:', error);
      throw error;
    }
  },

  /**
   * Mettre à jour une demande (Admin/Agent)
   * @param {string} id
   * @param {Object} data
   * @returns {Promise}
   */
  updateRequest: async (id, data) => {
    try {
      const response = await api.patch(`/requests/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la demande:', error);
      throw error;
    }
  },
};

export default requestService;
